import moment from 'moment';

angular.module('am4')
.service('UserService', function($http, $cookies, $q, $log, $translate, jwtHelper, appCacheService, LogglyLogger, config, apiUrl) {
    var that = this;
    that.token = null;
    that.user = null;

    window.$cookies = $cookies;

    that.init = function() {
        that.getSetToken();
        that.initUser();
    };

    that.login = function(email, password) {
        return $http.post(apiUrl + '/auth/login', {
            email,
            password
        })
        .then(function(res) {
            if (res.status !== 200) {
                return $q.reject([res.data.error, res.data.error_description]);
            }
            that.getSetToken(res.data);
            return that.loadUser();
        });
    };

    that.logout = function() {
        return that.clearUser()
        .then(function() {
            that.clearToken();
            appCacheService.clearCache();
        });
    };

    that.loadUser= function() {
        that.user = $http.get(apiUrl + '/users/' + encodeURIComponent(that.token.decoded.sub))
        .then(function(res) {
            LogglyLogger.fields({
                user: that.token.decoded.sub
            });

            $translate.preferredLanguage(res.data.language);
            return res.data;
        });

        return that.user;
    };

    that.initUser = function() {
        if (that.token && !that.user) {
            that.loadUser();
        } else {
            that.user = $q.reject();
        }

        return that.user;
    };

    that.clearUser = function() {
        that.user = $q.resolve(null);
        return that.user;
    };

    that.getSetToken = function(token) {
        if (token) {
            var exp = jwtHelper.decodeToken(token.id_token).exp;

            $cookies.put('token', JSON.stringify(token),{
                expires: moment.unix(exp).format()
            });
        }

        let tkn;
        try {
            tkn = JSON.parse($cookies.get('token'));
            if (tkn) {
                tkn.decoded = jwtHelper.decodeToken(tkn.id_token);
            }
        } catch (e) {
            tkn = null;
        }

        if (tkn && !jwtHelper.isTokenExpired(tkn.id_token)) {
            $http.defaults.headers.common.Authorization = 'Bearer ' + tkn.id_token;
        }

        that.token = tkn;
        return that.token;
    };

    that.clearToken = function() {
        $cookies.remove('token');

        that.token = null;

        return that.token;
    };

    that.init();
});



// WEBPACK FOOTER //
// ./src/app/services/user.js